import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Firebase Web SDK DISABLED for iOS compatibility
// import { getMessaging } from 'firebase/messaging';
// import { getApp, initializeApp } from 'firebase/app';

// let app;
// try {
//   app = getApp();
// } catch (e) {
//   app = initializeApp(environment.firebaseConfig);
// }
// export const messaging = getMessaging(app);

export const messaging = null; // Firebase Web SDK disabled

// Firebase service worker also disabled for now
// platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .then(() => {
//     if (!Capacitor.isNativePlatform()) {
//       if ('serviceWorker' in navigator) {
//         navigator.serviceWorker
//           .register(environment.firebaseSW)
//           .then(registration => {
//             console.log('Firebase SW registered:', registration);
//           })
//           .catch(err => console.error('SW registration failed:', err));
//       }
//     } else {
//       console.log('Native platform detected, skipping service worker');
//     }
//   })
//   .catch(err => {
//     console.error('Bootstrap failed:', err);
//     if (Capacitor.getPlatform() === 'ios') {
//       console.error('iOS-specific bootstrap error:', err);
//     }
//   });

// platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .then(() => {
//     if (!Capacitor.isNativePlatform())
//       if ('serviceWorker' in navigator) {
//         navigator.serviceWorker
//           .register(environment.firebaseSW)
//           .then(registration => {
//             console.log('Firebase SW registered:', registration);
//           })
//           .catch(err => console.error('SW registration failed:', err));
//       }
//   })
//   .catch(err => console.error(err));

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    // Firebase service worker disabled for iOS compatibility
    console.log('Firebase Web SDK disabled - using native push notifications only');

    // if (!Capacitor.isNativePlatform()) {
    //   if ('serviceWorker' in navigator) {
    //     navigator.serviceWorker
    //       .register(environment.firebaseSW)
    //       .then(registration => {
    //         console.log('Firebase SW registered:', registration);
    //       })
    //       .catch(err => console.error('SW registration failed:', err));
    //   }
    // } else {
    //   console.log('Native platform detected, skipping service worker');
    // }
  })
  .catch(err => {
    console.error('Bootstrap failed:', err);
    // Add platform-specific error handling
    if (Capacitor.getPlatform() === 'ios') {
      console.error('iOS-specific bootstrap error:', err);
    }
  });
